require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-is-the-world-bank-supporting-genocide-in-myanmar.json") })
        }
      }, "path---en-us-update-is-the-world-bank-supporting-genocide-in-myanmar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-is-the-world-bank-supporting-genocide-in-myanmar!./.cache/json/en-us-update-is-the-world-bank-supporting-genocide-in-myanmar.json
// module id = 767
// module chunks = 231608221292675